/**
 * useCompteDemo.ts — S232 (P-S232-10, M5 et lot 16) : vrai quand le tenant actif est le compte démo (estTenantDemo, demo-tenant.ts), faux
 * sinon et tant que la réponse n'est pas arrivée. Même lecture que BandeauDemo.tsx : GET /api/v1/auth/me avec le jeton du navigateur, sans
 * import de l'interface précédente (garde-fou V2IMPORTS.GUARD.1). Pour tout autre compte, les écrans qui l'utilisent ne changent pas.
 */

import { useEffect, useState } from "react";
import { estTenantDemo, membershipActif } from "./demo-tenant";

const _KEY = (import.meta as unknown as { env?: Record<string, string | undefined> }).env?.VITE_API_KEY || "missing-key";

export function useCompteDemo(): boolean {
  const [demo, setDemo] = useState(false);
  useEffect(() => {
    let vivant = true;
    let jwt: string | null = null;
    try { jwt = localStorage.getItem("ghostx-jwt"); } catch { jwt = null; }
    if (!jwt) return;
    fetch("/api/v1/auth/me", { headers: { "X-API-Key": _KEY, Authorization: `Bearer ${jwt}` } })
      .then((r) => (r.ok ? r.json() : null))
      .then((me) => { if (vivant) setDemo(estTenantDemo(membershipActif(me))); })
      .catch(() => { /* sans réponse : pas de démo */ });
    return () => { vivant = false; };
  }, []);
  return demo;
}
